// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/indirizzi/:indirizzoId',
    requestBody: '{"tipo":"string","nome":"string","via":"string","cap":"string","citta":"string","provincia":"string","paese":"string","principale":"boolean"}',
    response: '{"id":"number"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/indirizzi',
    requestBody: '{"tipo":"string","nome":"string","via":"string","cap":"string","citta":"string","provincia":"string","paese":"string","principale":"boolean"}',
    response: '{"id":"number"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/nominativi/:id/indirizzi/:indirizzoId',
    requestBody: null,
    response: '{"success":"boolean","message":"string"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
